import { useTranslation } from '@app/core/i18n';
import { Constants } from '../constants';

export const useUserRetrievalTranslation = () => useTranslation(Constants.I18N_NS);
